import { CapacitorUpdater } from '@capgo/capacitor-updater'
import { App } from '@capacitor/app'
import { MEMBER_DISPLAY_CACHE_SCHEMA_VERSION } from './lib/memberDisplayCache'
import { MEMBERS_BUNDLE_FINGERPRINT, loadedBundleAssetUrls, verifyRunningMembersBundle } from './bundleFingerprint'

let readinessNotificationPromise = null

export function notifyMembersMobileBundleReady({ updater = CapacitorUpdater, verify = verifyRunningMembersBundle } = {}) {
  if (!readinessNotificationPromise) {
    // Keep this import statically discoverable so Vite includes the native plugin
    // bridge in the Members bundle. An indirect runtime import leaves the WebView
    // trying (and failing) to resolve the bare package specifier itself.
    readinessNotificationPromise = (async () => {
      const result = await verify()
      if (!result.ok) {
        console.warn('[members-bundle] readiness withheld', result.reason)
        return false
      }
      await updater.notifyAppReady()
      return true
    })().catch((error) => {
      console.warn('[capgo] notifyAppReady failed', error?.message || 'unknown error')
      return false
    })
  }

  return readinessNotificationPromise
}

export async function logMembersMobileBundleVersions({ updater = CapacitorUpdater, app = App } = {}) {
  const [native, current, builtin, channel] = await Promise.all([
    app.getInfo().catch(() => null),
    updater.current().catch(() => null),
    updater.getBuiltinVersion().catch(() => null),
    updater.getChannel().catch(() => null),
  ])
  const activeVersion = current?.bundle?.version || builtin?.version || null
  const assets = loadedBundleAssetUrls()
  const details = {
    nativeVersion: native?.version || null,
    nativeBuild: native?.build || null,
    webBundleVersion: activeVersion,
    capgoChannel: channel?.channel || null,
    activeBundleId: current?.bundle?.id || 'builtin',
    cacheSchemaVersion: MEMBER_DISPLAY_CACHE_SCHEMA_VERSION,
    expectedOtaVersion: MEMBERS_BUNDLE_FINGERPRINT.otaVersion,
    gitSha: MEMBERS_BUNDLE_FINGERPRINT.gitSha,
    loadedStylesheets: assets.stylesheets,
    loadedScripts: assets.scripts,
  }
  if (import.meta.env.DEV || import.meta.env.MODE === 'test') console.info('[members-mobile-version]', details)
  else if (activeVersion && activeVersion !== MEMBERS_BUNDLE_FINGERPRINT.otaVersion) {
    console.warn('[members-bundle] active version does not match built fingerprint')
  }
  return details
}

export function resetMembersMobileBundleReadyForTest() {
  readinessNotificationPromise = null
}
